exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".slide[data-v-e498f862]{color:#fff;text-align:center;font-size:6rem}.button-container[data-v-e498f862]{padding-top:10px;width:50%;margin:0 auto}.anim[data-v-e498f862]{width:50px;height:50px}", ""]);

// exports
